import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13ef2769"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-goods-card" }
const _hoisted_2 = {
  key: 0,
  class: "order-id"
}
const _hoisted_3 = { class: "after-goods-box" }
const _hoisted_4 = { class: "after-goods" }
const _hoisted_5 = { class: "goods-img" }
const _hoisted_6 = { class: "after-goods-main" }
const _hoisted_7 = { class: "after-goods-title" }
const _hoisted_8 = { class: "after-goods-msg" }
const _hoisted_9 = { class: "after-goods-spec" }
const _hoisted_10 = { class: "goods-spec" }
const _hoisted_11 = { class: "tip-msg" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_13 = {
  key: 2,
  class: "after-goods-box"
}
const _hoisted_14 = { class: "after-goods" }
const _hoisted_15 = { class: "after-goods-main" }
const _hoisted_16 = { class: "after-goods-title" }
const _hoisted_17 = { class: "after-goods-msg" }
const _hoisted_18 = { class: "after-goods-spec" }
const _hoisted_19 = { class: "goods-spec" }


import KiliButton from "@/components/KiliButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'afterGoodsCard',
  props: {
    /** orderId 订单id  */
    orderId: [Number, String],
    /**goodsData 商品数据 数据格式可为数组或对象，为数组时显示多个商品，对象则显示一个 参数如下：
     * goods_num  商品数量
     * sku_image 商品图片
     * goods_spec 商品规格信息 列入 32G Bule
     * 
     */
    goodsData: {
        type: [Object, Array],
        require: true
    },
    /** 订单id的标题 */
    title: {
        type:String,
        default:'order No:'
    },
    /** 是否显示Apply按钮 目前只有可售后列表页有这个需求 */
    // showApply: {
    //     type: Boolean,
    //     default: false
    // },
    /** isNum 是否显示计数器 */
    isNum: {
        type: Boolean,
        default: false
    },
    step: {
        type: Number,
        default: 1
    },


},
  emits: ['handleNum', 'apply'],
  setup(__props, { emit }) {

const props = __props



// goodsNum.value = props.goodsData.goods_num
const handleNum = (type: any,step:number, goods?: any) => {
    emit('handleNum', type,step, goods)
}
const handleApply = (goods?: any) => {
    emit('apply', goods)
}

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_stepper = _resolveComponent("van-stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.orderId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title) + _toDisplayString(__props.orderId), 1))
      : _createCommentVNode("", true),
    (Array.isArray(__props.goodsData))
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.goodsData, (goodsItem, i) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_van_image, {
                  width: "1.92rem",
                  height: "1.92rem",
                  src: _ctx.webpFilters(goodsItem.sku_image),
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(goodsItem.sku_name), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodsItem.sku_map, (goodsSpec, index) => {
                        return (_openBlock(), _createElementBlock("span", null, _toDisplayString(goodsSpec) + _toDisplayString(index < goodsItem.sku_map.length - 1 ? ', ' : '  '), 1))
                      }), 256))
                    ]),
                    _createElementVNode("span", null, " x" + _toDisplayString(goodsItem.goods_num), 1)
                  ]),
                  (__props.isNum && goodsItem.goods_num > 0)
                    ? (_openBlock(), _createBlock(_component_van_stepper, {
                        key: 0,
                        modelValue: goodsItem.editNum,
                        "onUpdate:modelValue": ($event: any) => ((goodsItem.editNum) = $event),
                        step: __props.step,
                        max: goodsItem.goods_num,
                        "input-width": "1.02rem",
                        "button-size": "0.55rem",
                        integer: "",
                        "disable-input": "",
                        onPlus: ($event: any) => (handleNum('plus',__props.step,i)),
                        onMinus: ($event: any) => (handleNum('minus',__props.step,i))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "max", "onPlus", "onMinus"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(goodsItem.apply_switch ? 'after-goods-b-btn' : 'not-apply')
            }, [
              (goodsItem.apply_switch)
                ? (_openBlock(), _createBlock(KiliButton, {
                    key: 0,
                    plain: "",
                    textColor: "#E04545",
                    radiusSize: "6px",
                    bordersColor: "#E04545",
                    title: "Apply",
                    onClick: ($event: any) => (handleApply(goodsItem))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (!goodsItem.apply_switch && goodsItem.apply_switch_reason)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(goodsItem.apply_switch_reason), 1),
                      _hoisted_12
                    ]),
                    _createVNode(KiliButton, {
                      plain: "",
                      textColor: "#999999",
                      radiusSize: "6px",
                      bordersColor: "#999999",
                      title: "Apply",
                      onClick: ($event: any) => (handleApply(goodsItem))
                    }, null, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        }), 256))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", null, [
              _createVNode(_component_van_image, {
                width: "1.92rem",
                height: "1.92rem",
                src: _ctx.webpFilters(__props.goodsData.sku_image),
                fit: "cover"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, _toDisplayString(__props.goodsData.sku_name), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.goodsData.sku_map, (goodsSpec, index) => {
                      return (_openBlock(), _createElementBlock("span", null, _toDisplayString(goodsSpec) + _toDisplayString(index < __props.goodsData.sku_map.length - 1 ? ', ' : '  '), 1))
                    }), 256))
                  ]),
                  _createElementVNode("span", null, " x" + _toDisplayString(__props.goodsData.goods_num), 1)
                ])
              ])
            ])
          ])
        ]))
  ]))
}
}

})